import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import '@doseme/cohesive-ui/dist/style/global.css'
import '@doseme/cohesive-ui/dist/cohesive-ui.esm.css'

import { ROOT_URL } from './constants/urls/frontend'
import { configureStore } from './store/configureStore'
import { initialState } from './store'
import { DashboardContainer } from './scenes/Dashboard/DashboardContainer'

import './index.scss'

const store = configureStore(initialState)

declare global {
  // tslint:disable:interface-name
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__: any
    env: {
      REACT_APP_DOSEME_URL: string
      REACT_APP_ADMIN_URL: string
      REACT_APP_AZURE_CLIENT_ID: string
      REACT_APP_AZURE_TENANT_ID: string
    }
  }
}

if (process.env.NODE_ENV === 'development') {
  window.env.REACT_APP_DOSEME_URL = process.env.REACT_APP_DOSEME_URL ? process.env.REACT_APP_DOSEME_URL : ''
  window.env.REACT_APP_ADMIN_URL = process.env.REACT_APP_ADMIN_URL ? process.env.REACT_APP_ADMIN_URL : ''
  window.env.REACT_APP_AZURE_CLIENT_ID = process.env.REACT_APP_AZURE_CLIENT_ID ? process.env.REACT_APP_AZURE_CLIENT_ID : ''
  window.env.REACT_APP_AZURE_TENANT_ID = process.env.REACT_APP_AZURE_TENANT_ID ? process.env.REACT_APP_AZURE_TENANT_ID : ''
}

ReactDOM.render(
  <Provider store={store}>
    <Router>
      <Switch>
        <Route path={ROOT_URL} component={DashboardContainer} />
      </Switch>
    </Router>
  </Provider>, document.getElementById('root')
)
